// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_actuals_res_values.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "stcs_cmw";

/** v2.1.0 */
export interface StcsCompActualsResValues {
  id: string;
  version: string;
  meta: StcsCompActualsResValuesMeta | undefined;
  pnl_map: { [key: string]: StcsCompActualsResValuesItem };
  bs_map: { [key: string]: StcsCompActualsResValuesItem };
  cf_map: { [key: string]: StcsCompActualsResValuesItem };
}

export interface StcsCompActualsResValues_PnlMapEntry {
  key: string;
  value: StcsCompActualsResValuesItem | undefined;
}

export interface StcsCompActualsResValues_BsMapEntry {
  key: string;
  value: StcsCompActualsResValuesItem | undefined;
}

export interface StcsCompActualsResValues_CfMapEntry {
  key: string;
  value: StcsCompActualsResValuesItem | undefined;
}

export interface StcsCompActualsResValuesMeta {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  is_draft: boolean;
  fpna_begin_date_string: string;
  fpna_end_date_string: string;
  /**
   * TODO
   * string actuals_data_begin_date_string = 5;
   * string actuals_data_end_date_string = 6;
   */
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
}

export interface StcsCompActualsResValuesItem {
  values_map: { [key: string]: number };
}

export interface StcsCompActualsResValuesItem_ValuesMapEntry {
  key: string;
  value: number;
}

function createBaseStcsCompActualsResValues(): StcsCompActualsResValues {
  return { id: "", version: "", meta: undefined, pnl_map: {}, bs_map: {}, cf_map: {} };
}

export const StcsCompActualsResValues: MessageFns<StcsCompActualsResValues> = {
  encode(message: StcsCompActualsResValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompActualsResValuesMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    Object.entries(message.pnl_map).forEach(([key, value]) => {
      StcsCompActualsResValues_PnlMapEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    Object.entries(message.bs_map).forEach(([key, value]) => {
      StcsCompActualsResValues_BsMapEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    Object.entries(message.cf_map).forEach(([key, value]) => {
      StcsCompActualsResValues_CfMapEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompActualsResValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompActualsResValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompActualsResValuesMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = StcsCompActualsResValues_PnlMapEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.pnl_map[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = StcsCompActualsResValues_BsMapEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.bs_map[entry5.key] = entry5.value;
          }
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = StcsCompActualsResValues_CfMapEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.cf_map[entry6.key] = entry6.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompActualsResValues {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompActualsResValuesMeta.fromJSON(object.meta) : undefined,
      pnl_map: isObject(object.pnl_map)
        ? Object.entries(object.pnl_map).reduce<{ [key: string]: StcsCompActualsResValuesItem }>(
          (acc, [key, value]) => {
            acc[key] = StcsCompActualsResValuesItem.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      bs_map: isObject(object.bs_map)
        ? Object.entries(object.bs_map).reduce<{ [key: string]: StcsCompActualsResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompActualsResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
      cf_map: isObject(object.cf_map)
        ? Object.entries(object.cf_map).reduce<{ [key: string]: StcsCompActualsResValuesItem }>((acc, [key, value]) => {
          acc[key] = StcsCompActualsResValuesItem.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompActualsResValues): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompActualsResValuesMeta.toJSON(message.meta);
    }
    if (message.pnl_map) {
      const entries = Object.entries(message.pnl_map);
      if (entries.length > 0) {
        obj.pnl_map = {};
        entries.forEach(([k, v]) => {
          obj.pnl_map[k] = StcsCompActualsResValuesItem.toJSON(v);
        });
      }
    }
    if (message.bs_map) {
      const entries = Object.entries(message.bs_map);
      if (entries.length > 0) {
        obj.bs_map = {};
        entries.forEach(([k, v]) => {
          obj.bs_map[k] = StcsCompActualsResValuesItem.toJSON(v);
        });
      }
    }
    if (message.cf_map) {
      const entries = Object.entries(message.cf_map);
      if (entries.length > 0) {
        obj.cf_map = {};
        entries.forEach(([k, v]) => {
          obj.cf_map[k] = StcsCompActualsResValuesItem.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompActualsResValues>, I>>(base?: I): StcsCompActualsResValues {
    return StcsCompActualsResValues.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompActualsResValues>, I>>(object: I): StcsCompActualsResValues {
    const message = createBaseStcsCompActualsResValues();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompActualsResValuesMeta.fromPartial(object.meta)
      : undefined;
    message.pnl_map = Object.entries(object.pnl_map ?? {}).reduce<{ [key: string]: StcsCompActualsResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompActualsResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.bs_map = Object.entries(object.bs_map ?? {}).reduce<{ [key: string]: StcsCompActualsResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompActualsResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.cf_map = Object.entries(object.cf_map ?? {}).reduce<{ [key: string]: StcsCompActualsResValuesItem }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsCompActualsResValuesItem.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsCompActualsResValues_PnlMapEntry(): StcsCompActualsResValues_PnlMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompActualsResValues_PnlMapEntry: MessageFns<StcsCompActualsResValues_PnlMapEntry> = {
  encode(message: StcsCompActualsResValues_PnlMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompActualsResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompActualsResValues_PnlMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompActualsResValues_PnlMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompActualsResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompActualsResValues_PnlMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompActualsResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompActualsResValues_PnlMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompActualsResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompActualsResValues_PnlMapEntry>, I>>(
    base?: I,
  ): StcsCompActualsResValues_PnlMapEntry {
    return StcsCompActualsResValues_PnlMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompActualsResValues_PnlMapEntry>, I>>(
    object: I,
  ): StcsCompActualsResValues_PnlMapEntry {
    const message = createBaseStcsCompActualsResValues_PnlMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompActualsResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompActualsResValues_BsMapEntry(): StcsCompActualsResValues_BsMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompActualsResValues_BsMapEntry: MessageFns<StcsCompActualsResValues_BsMapEntry> = {
  encode(message: StcsCompActualsResValues_BsMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompActualsResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompActualsResValues_BsMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompActualsResValues_BsMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompActualsResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompActualsResValues_BsMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompActualsResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompActualsResValues_BsMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompActualsResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompActualsResValues_BsMapEntry>, I>>(
    base?: I,
  ): StcsCompActualsResValues_BsMapEntry {
    return StcsCompActualsResValues_BsMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompActualsResValues_BsMapEntry>, I>>(
    object: I,
  ): StcsCompActualsResValues_BsMapEntry {
    const message = createBaseStcsCompActualsResValues_BsMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompActualsResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompActualsResValues_CfMapEntry(): StcsCompActualsResValues_CfMapEntry {
  return { key: "", value: undefined };
}

export const StcsCompActualsResValues_CfMapEntry: MessageFns<StcsCompActualsResValues_CfMapEntry> = {
  encode(message: StcsCompActualsResValues_CfMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsCompActualsResValuesItem.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompActualsResValues_CfMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompActualsResValues_CfMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsCompActualsResValuesItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompActualsResValues_CfMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsCompActualsResValuesItem.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsCompActualsResValues_CfMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsCompActualsResValuesItem.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompActualsResValues_CfMapEntry>, I>>(
    base?: I,
  ): StcsCompActualsResValues_CfMapEntry {
    return StcsCompActualsResValues_CfMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompActualsResValues_CfMapEntry>, I>>(
    object: I,
  ): StcsCompActualsResValues_CfMapEntry {
    const message = createBaseStcsCompActualsResValues_CfMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsCompActualsResValuesItem.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsCompActualsResValuesMeta(): StcsCompActualsResValuesMeta {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    is_draft: false,
    fpna_begin_date_string: "",
    fpna_end_date_string: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
  };
}

export const StcsCompActualsResValuesMeta: MessageFns<StcsCompActualsResValuesMeta> = {
  encode(message: StcsCompActualsResValuesMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.is_draft !== false) {
      writer.uint32(32).bool(message.is_draft);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(42).string(message.fpna_begin_date_string);
    }
    if (message.fpna_end_date_string !== "") {
      writer.uint32(50).string(message.fpna_end_date_string);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(58).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(66).string(message.obj_updated_iso_utc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompActualsResValuesMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompActualsResValuesMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fpna_end_date_string = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompActualsResValuesMeta {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
      fpna_end_date_string: isSet(object.fpna_end_date_string) ? globalThis.String(object.fpna_end_date_string) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
    };
  },

  toJSON(message: StcsCompActualsResValuesMeta): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    if (message.fpna_end_date_string !== "") {
      obj.fpna_end_date_string = message.fpna_end_date_string;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompActualsResValuesMeta>, I>>(base?: I): StcsCompActualsResValuesMeta {
    return StcsCompActualsResValuesMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompActualsResValuesMeta>, I>>(object: I): StcsCompActualsResValuesMeta {
    const message = createBaseStcsCompActualsResValuesMeta();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.is_draft = object.is_draft ?? false;
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    message.fpna_end_date_string = object.fpna_end_date_string ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    return message;
  },
};

function createBaseStcsCompActualsResValuesItem(): StcsCompActualsResValuesItem {
  return { values_map: {} };
}

export const StcsCompActualsResValuesItem: MessageFns<StcsCompActualsResValuesItem> = {
  encode(message: StcsCompActualsResValuesItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.values_map).forEach(([key, value]) => {
      StcsCompActualsResValuesItem_ValuesMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompActualsResValuesItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompActualsResValuesItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsCompActualsResValuesItem_ValuesMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.values_map[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompActualsResValuesItem {
    return {
      values_map: isObject(object.values_map)
        ? Object.entries(object.values_map).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsCompActualsResValuesItem): unknown {
    const obj: any = {};
    if (message.values_map) {
      const entries = Object.entries(message.values_map);
      if (entries.length > 0) {
        obj.values_map = {};
        entries.forEach(([k, v]) => {
          obj.values_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompActualsResValuesItem>, I>>(base?: I): StcsCompActualsResValuesItem {
    return StcsCompActualsResValuesItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompActualsResValuesItem>, I>>(object: I): StcsCompActualsResValuesItem {
    const message = createBaseStcsCompActualsResValuesItem();
    message.values_map = Object.entries(object.values_map ?? {}).reduce<{ [key: string]: number }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsCompActualsResValuesItem_ValuesMapEntry(): StcsCompActualsResValuesItem_ValuesMapEntry {
  return { key: "", value: 0 };
}

export const StcsCompActualsResValuesItem_ValuesMapEntry: MessageFns<StcsCompActualsResValuesItem_ValuesMapEntry> = {
  encode(
    message: StcsCompActualsResValuesItem_ValuesMapEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompActualsResValuesItem_ValuesMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompActualsResValuesItem_ValuesMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompActualsResValuesItem_ValuesMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: StcsCompActualsResValuesItem_ValuesMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompActualsResValuesItem_ValuesMapEntry>, I>>(
    base?: I,
  ): StcsCompActualsResValuesItem_ValuesMapEntry {
    return StcsCompActualsResValuesItem_ValuesMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompActualsResValuesItem_ValuesMapEntry>, I>>(
    object: I,
  ): StcsCompActualsResValuesItem_ValuesMapEntry {
    const message = createBaseStcsCompActualsResValuesItem_ValuesMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
